import React, { useState, useEffect } from 'react';
import {
  Form,
  Input,
  Button,
  Select,
  DatePicker,
  Upload,
  message,
  Row,
  Col,
  Typography,
  Modal,
  Checkbox,
  Spin,
} from 'antd';
import {
  UploadOutlined,
  DeleteOutlined,
  ExclamationCircleOutlined,
  DownloadOutlined,
  LeftOutlined,
  RightOutlined,
  ArrowRightOutlined
} from '@ant-design/icons';
import moment from 'moment';
import LeftLayout from '../pageHeader/LeftLayout';
import {
  COMMON_ERROR_MSG,
  SUBMISSION_FAILED,
  RECORD_SAVED_MSG,
  FILE_SIZE_VALIDATION,
  FILE_TYPE_VALIDATION,
  DELETE_IMAGE_CONFIRMATION_PLAIN_MESSAGE,
  APP_BLOB_ROOT,
} from '../../constants/constants';
import _NewapplicationService from '../../modules/NewapplicationService';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { routes } from '../../routes/Routes';
import ShowApplicationId from "../NewApplication/ShowApplicationId";
import ButtonComponent from '../../components/Button/Button';
import ApplicationProgressBar from './ApplicationProgressBar';

const { Title, Text } = Typography;
const { Option } = Select;
const { confirm } = Modal;

const ProofOfTrust = () => {
  const [form] = Form.useForm();
  const [trusttypes, setTrustTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [fileList, setFileList] = useState([]);
  const [docPath, setDocPath] = useState();
  const [applicantInfo, setApplicantInfo] = useState({});
  const applicationId = localStorage.getItem("ApplicationId");

  const history = useHistory();


  const ID = localStorage.getItem('Id');
  const APPLICATION_TYPE_ID = localStorage.getItem('applicationTypeId');
  const location = useLocation();
  let data = location.state;
  let applnObjId = "";
  let activeKeyTab = null;
  let fromDashboard = false;

  if (data && data.applicationObjId) {
    applnObjId = data.applicationObjId;
  }

  if (data && data.isFromDashboard) {
    fromDashboard = data.isFromDashboard;
  }

  if (data && data.isFromDashboard) {
    fromDashboard = data.isFromDashboard;
  }

  if (data && data.activeKey) {
    activeKeyTab = data.activeKey;
  }

  const [appObjId] = useState(applnObjId);
  const [isFromDashboard] = useState(fromDashboard);
  const [tabActiveKey] = useState(activeKeyTab);
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const fileFormatText = (
    <Text type="secondary" style={{ fontSize: 12, marginLeft: 10 }}>
      Format: pdf, doc, docx &nbsp;&nbsp; Size: Up to 25MB.
    </Text>
  );

  const beforeUpload = (file) => {
    return new Promise(async (resolve, reject) => {
      const isValidType = ['application/pdf', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'].includes(file.type);
      // const isValidSize = file.size >= 155 * 1024 && file.size <= 350 * 1024;
      const isValidSize = file.size <= 25 * 1024 * 1024;

      if (!isValidType) {
        message.error("Only PDF/DOC/DOCX files are allowed!");
        return reject(Upload.LIST_IGNORE);
      }
      if (!isValidSize) {
        message.error("File size must be up to 25MB!");
        return reject(Upload.LIST_IGNORE);
      }

      setUploading(true);
      const formData = new FormData();
      formData.append('files[]', file);

      try {
        const res = await _NewapplicationService.UploadPdfOrDocFile(formData, ID, 'certificationoftrust');
        if (res?.data?.IsSucess && res.data.URL) {
          const relPath = new URL(res.data.URL).pathname;
          setDocPath(relPath);
          setFileList([{ uid: file.uid, name: "Certification of Trust", status: 'done', url: res.data.URL }]);

          form.setFieldsValue({
            certificationOfTrust: [
              { uid: file.uid, name: "Certification of Trust", status: 'done', url: res.data.URL }
            ],
          });
          // form.validateFields(['certificationOfTrust']);
          resolve(false); // prevent default upload
        } else {
          message.error(res?.data?.Message || 'Upload failed');
          reject(Upload.LIST_IGNORE);
        }
      } catch {
        message.error('Server error during upload');
        reject(Upload.LIST_IGNORE);
      } finally {
        setUploading(false);
      }
    });
  };


  const onRemove = file => {
    confirm({
      title: "Are you sure, want to delete this Certification Of Trust? ",
      icon: <ExclamationCircleOutlined />,
      onOk() {
        setDocPath(undefined);
        setFileList([]);
      },
    });
    return false;
  };

  const getTrustTypes = async () => {
    try {
      const res = await _NewapplicationService.getAllDropdownDataByName('trusttypes');
      if (res.data) setTrustTypes(res.data);
    } catch { }
  };

  const getApplicant = async () => {
    setLoading(true);
    try {
      const res = await _NewapplicationService.getApplicantInformationByApplicationId(isFromDashboard ? appObjId : ID);
      if (res.data) {
        const d = res.data;
        setApplicantInfo({
          ...d,
          typeOfTrust: d.Pot_Trust_Type_Id,
          legalName: d.Pot_Legal_Name_Of_Trust,
          grantorName: d.Pot_Name_Of_Grantor,
          trustCreationDate: d.Pot_Date_Of_Trust_Creation ? moment(d.Pot_Date_Of_Trust_Creation) : null,
          taxId: d.Pot_Trust_Tax_Id,
          StateOfTrustFormation: d.Pot_State_Of_Trust_Formation,
        });
        if (d.Pot_Certificate_Of_Trust_Path) {
          // const url = APP_BLOB_ROOT + d.Pot_Certificate_Of_Trust_Path;
          const url = d.Pot_Certificate_Of_Trust_Path;
          // const url = "https://levridgestorage.blob.core.windows.net/certificationoftrust/10068.pdf?sv=2020-08-04&se=2025-08-08T10%3A20%3A57Z&sr=b&sp=r&sig=MLyEzUO1VWUK2JpHr%2BLWY%2FR5SEiioOCfJVJILHCeTbA%3D";
          const relPath = new URL(d.Pot_Certificate_Of_Trust_Path).pathname;
          setDocPath(relPath);
          setFileList([{ uid: '-initial', name: "Certification of Trust", status: 'done', url }]);
          // setFileList([{ uid: '-initial', name: url.split('/').pop(), status: 'done', url }]);
        }
      }
    } catch { }
    setLoading(false);
  };

  useEffect(() => {
    getTrustTypes();
    getApplicant();
  }, []);

  useEffect(() => {
    form.resetFields();
  }, [applicantInfo]);

  const onFinish = async values => {
    setLoading(true);
    const payload = {
      Id: ID,
      ScreenName: 'proofoftrust',
      ApplicationId: localStorage.getItem('ApplicationId'),
      Pot_Trust_Type_Id: values.typeOfTrust,
      Pot_Legal_Name_Of_Trust: values.legalName,
      Pot_Name_Of_Grantor: values.grantorName,
      Pot_Date_Of_Trust_Creation: values.trustCreationDate?.format('YYYY-MM-DD'),
      Pot_Trust_Tax_Id: values.taxId,
      Pot_State_Of_Trust_Formation: values.StateOfTrustFormation,
      Pot_Certificate_Of_Trust_Path: docPath,
      IsProofofTrustCompleted: true,
    };

    try {
      const res = await _NewapplicationService.submitApplicantData(payload);
      if (res.data.IsSuccess) {
        setLoading(false);
        message.success(res.data.Message || RECORD_SAVED_MSG);
        if (isFromDashboard) {
          history.push({ pathname: routes.dashboard.path, state: { appObjId, activeKey: activeKeyTab } });

        } else {
          if (APPLICATION_TYPE_ID == "3") {
            history.push({ pathname: routes.applicantsIdentification.path });
          } else if (APPLICATION_TYPE_ID == "4") {
            history.push({ pathname: routes.coBorrowersDetails.path });
          } else {
            history.push({ pathname: routes.uploaddocuments.path });
          }
        }
      } else {
        setLoading(false);
        message.error(res.data.Message || COMMON_ERROR_MSG);
      }
    } catch (err) {
      setLoading(false);
      message.error(err.message || SUBMISSION_FAILED);
    } finally {
      setLoading(false);
    }
  };

  const onBack = () => {
    if (isFromDashboard) {
      history.push({ pathname: routes.dashboard.path, state: { appObjId, activeKey: tabActiveKey } });
    } else {
      history.push(routes.ApplicantsDetails.path);
    }
  }

  const disableFutureDates = (current) => {
    return current && current > moment().endOf("day");
  };

  return (
    <LeftLayout>
      <div>
        {applicationId && applicationId !== 'undefined' && applicationId !== 'null' && (
          <div>
            <ApplicationProgressBar />
            <Title level={5}>
              {/* <ShowApplicationId /> */}
            </Title>
          </div>
        )}
      </div>
      <Spin spinning={loading || uploading}>
        <div className="application-dark-page">
          <div className="application-card">

            <Row>
              <Col span={24}>
                <Title level={3} style={{ marginBottom: 25 }}>
                  Proof Of Trust
                </Title>
                <Form form={form} layout="vertical" onFinish={onFinish} initialValues={applicantInfo}>
                  <Row gutter={16}>
                    <Col xs={24} md={12}>
                      <Form.Item label="Type Of Trust" name="typeOfTrust"
                        rules={[{ required: true, message: "Type Of Trust is required" }]}
                      >
                        <Select placeholder="Select Type Of Trust">
                          {trusttypes.map(t => <Option key={t.Id} value={t.Id}>{t.Name}</Option>)}
                        </Select>
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>
                      <Form.Item label="Legal Name Of The Trust" name="legalName"
                        rules={[{ required: true, message: "Legal Name Of The Trust is required" }]}
                      >
                        <Input placeholder="Enter Legal Name Of The Trust" />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={16}>
                    <Col xs={24} md={12}>
                      <Form.Item label="Name Of The Grantor" name="grantorName"
                        rules={[{ required: true, message: "Name Of The Grantor is required" }]}
                      >
                        <Input placeholder="Enter Name Of The Grantor" />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>

                      <Form.Item label="Date Of Trust Creation" name="trustCreationDate"
                        rules={[{ required: true, message: "Date Of Trust Creation is required" }]}
                      >
                        <DatePicker placeholder='Select Date Of Trust Creation' style={{ width: '100%' }} format="MM/DD/YYYY" disabledDate={disableFutureDates} />
                      </Form.Item>
                    </Col>
                  </Row>
                  <Row gutter={16}>
                    <Col xs={24} md={12}>
                      <Form.Item label="Trust’s Tax ID (If Any)" name="taxId"
                        rules={[{ required: true, message: "Trust’s Tax ID is required" }]}
                      >
                        <Input placeholder="Enter Trust’s Tax ID (If Any)" />
                      </Form.Item>
                    </Col>
                    <Col xs={24} md={12}>

                      <Form.Item label="State Of Trust Formation" name="StateOfTrustFormation"
                        rules={[{ required: true, message: "State Of Trust Formation is required" }]}
                      >
                        <Input placeholder="Enter State Of Trust Formation" />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Form.Item label="Download – Certificate of Trust">
                    <Button type="link" icon={<DownloadOutlined />} href="/blank.pdf" target="_blank">
                      Certificate of Trust
                    </Button>
                  </Form.Item>


                  <Form.Item
                    name="certificationOfTrust"
                    label="Certification of Trust"
                    required
                    rules={[
                      {
                        required: false,
                        validator: () => fileList.length ? Promise.resolve() : Promise.reject('Certification of Trust is required!'),
                      },
                    ]}
                  >
                    <Upload
                      className='uploadDiv mb5'
                      accept=".pdf,.doc,.docx"
                      beforeUpload={beforeUpload}
                      onRemove={onRemove}
                      fileList={fileList}
                      listType="picture"
                      maxCount={1}
                    >
                      {!fileList.length && <Button icon={<UploadOutlined />}>Click to Upload</Button>}
                    </Upload>
                    {fileFormatText}
                  </Form.Item>

                  <Form.Item name="ihereby" valuePropName="checked" className='mt20'
                    rules={[
                      {
                        validator: (_, value) =>
                          value
                            ? Promise.resolve()
                            : Promise.reject(new Error("Please confirm terms & conditions")),
                      },
                    ]}
                  >
                    <Checkbox>
                      I hereby declare that I have the legal authority to borrow funds, pledge assets, and sign loan documents on behalf of the trust
                    </Checkbox>
                  </Form.Item>

                  <Form.Item>
                    <Row justify="end" gutter={16}>
                      <Col>
                        {/* <Button
                          onClick={onBack}
                          icon={<LeftOutlined />}
                        >
                          Go Back
                        </Button> */}
                        <ButtonComponent
                          type="default"
                          onClick={onBack}
                          icon={<LeftOutlined />}
                          text="Go Back"
                        />
                      </Col>
                      <Col>
                        {/* <Button
                          type="primary"
                          htmlType="submit"
                          disabled={![1,2,4,9].includes(applicantInfo && applicantInfo.Application_Status_Id) ? true : false}
                        >
                          Save And Proceed <RightOutlined />
                        </Button> */}
                        <ButtonComponent
                          type="primary"
                          htmlType="submit"
                          disabled={[1, 2, 4, 9].includes(applicantInfo && applicantInfo.Application_Status_Id) ? false : true}
                          text={
                            <span>
                              Save And Proceed <ArrowRightOutlined />
                            </span>
                          }
                          // text="Save And Proceed"
                          icon={<RightOutlined />}
                        />
                      </Col>
                    </Row>
                  </Form.Item>
                </Form>
              </Col>
            </Row>
          </div>
        </div>
      </Spin>
    </LeftLayout>
  );
};

export default ProofOfTrust;

